import React from "react";
// import Navbar from "../components/Navbar";

import Partnership from "../Component/Partnership";
import Partmodel from "../Component/Partmodel";
import Partnershipbenifits from "../Component/Partnershipbenifits";
import Partnershipprocess from "../Component/Partnershipprocess";




const Partner = () => {
    return (
     <>
  {/* <Navbar/> */}
  <Partnership/>
  <Partmodel/>
  <Partnershipbenifits/>
  <Partnershipprocess/>
 
  
  
    
  
      
  </>
      
    );
  };
  
  export default Partner;
  